/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ContractPeriodMode;

(function (ContractPeriodMode) {
  ContractPeriodMode["ALWAYS_ON"] = "always_on";
  ContractPeriodMode["DEFAULT"] = "default";
})(ContractPeriodMode || (ContractPeriodMode = {}));